<template>
  <div class="package-registration container">
    <div class="d-flex justify-content-between align-items-center my-8">
      <div>
        <h4 class="text-dark fw-bold mb-1">Đăng ký Gói Dịch vụ</h4>
        <p class="text-muted m-0">Quản lý đăng ký gói của khách hàng</p>
      </div>
      <div class="d-flex gap-3">
        <button v-if="isViewPermission" class="btn btn-outline-success font-weight-medium mr-2" @click="exportReport">
          <i class="fas fa-download mr-2"></i>Xuất báo cáo
        </button>
        <button v-if="isInsertPermission" class="btn btn-outline-success font-weight-medium mr-2" @click="openBulkImport">
          <i class="fas fa-building mr-2"></i>Đăng ký theo doanh nghiệp
        </button>
        <button v-if="isInsertPermission" class="btn btn-outline-success font-weight-medium mr-2" @click="openListImport">
          <i class="fas fa-file-import mr-2"></i>Import danh sách khách hàng
        </button>
        <button v-if="isInsertPermission" class="btn btn-success font-weight-medium" @click="createRegistration">
          <i class="fas fa-plus mr-2"></i>Đăng ký mới
        </button>
      </div>
    </div>

    <package-registration-bulk-import @success="onBulkImportSuccess" />
    <user-bundle-orders-import @success="onBulkImportSuccess" />

    <div class="filter-bar bg-white rounded border mb-6">
      <div class="row align-items-center">
        <div class="col-md-2 filter-col-input">
          <div class="position-relative">
            <i class="fas fa-phone search-icon"></i>
            <input
              v-model="filters.phoneNumber"
              type="text"
              class="form-control search-input"
              placeholder="Số điện thoại khách hàng..."
              @input="handleSearch"
            />
          </div>
        </div>

        <div class="col-md-2">
          <basic-select
            label=""
            placeholder="Tất cả gói dịch vụ"
            name="salePackageId"
            :options="salePackageOptions"
            track-by="value"
            value-label="text"
            :value.sync="salePackageValue"
            @input="filters.salePackageId = $event != null ? $event : ''; handleSearch()"
          />
        </div>

        <div class="col-md-2">
          <basic-select
            label=""
            placeholder="Tất cả trạng thái"
            name="status"
            :options="statusOptions"
            track-by="value"
            value-label="text"
            :value.sync="statusValue"
            @input="filters.status = $event != null ? $event : ''; handleSearch()"
          />
        </div>

        <div class="col-md-2">
          <basic-date-picker
            :value.sync="filters.dateFrom"
            label=""
            placeholder="Từ ngày"
            name="dateFrom"
            format="DD/MM/YYYY"
            @input="handleSearch"
          />
        </div>

        <div class="col-md-2">
          <basic-date-picker
            :value.sync="filters.dateTo"
            label=""
            placeholder="Đến ngày"
            name="dateTo"
            format="DD/MM/YYYY"
            @input="handleSearch"
          />
        </div>

        <div class="col-md-2 p-2 filter-col-input d-flex align-items-center">
          <button class="btn btn-secondary btn-reset-filter w-100" @click="resetFilters">
          Reset bộ lọc
          </button>
        </div>
      </div>
    </div>

    <div class="row mb-5">
      <div class="col-md-4">
        <div class="summary-card">
          <div class="summary-card__label">Đang hoạt động</div>
          <div class="summary-card__value text-success">{{ stats.active }}</div>
        </div>
      </div>
      <div class="col-md-4">
        <div class="summary-card">
          <div class="summary-card__label">Hết hạn</div>
          <div class="summary-card__value text-dark">{{ stats.expired }}</div>
        </div>
      </div>
      <div class="col-md-4">
        <div class="summary-card">
          <div class="summary-card__label">Tổng doanh thu</div>
          <div class="summary-card__value text-success">{{ formatPrice(stats.revenue) }}</div>
        </div>
      </div>
    </div>

    <div class="mb-4">
      <span class="text-muted">Hiển thị {{ registrations.length }} đăng ký</span>
    </div>

    <b-overlay :show="loading">
      <div class="row">
        <div
          v-for="item in registrations"
          :key="item.id"
          class="col-12 mb-4"
        >
          <div class="registration-card">
            <div class="d-flex align-items-start justify-content-between flex-wrap">
              <div class="d-flex align-items-start flex-grow-1 pr-4">
                <div class="registration-icon mr-4">
                  <i class="fas fa-user-md"></i>
                </div>
                <div class="flex-grow-1">
                  <div class="d-flex align-items-center flex-wrap mb-1">
                    <div class="registration-title mr-3">{{ item.packageName }}</div>
                    <span :class="statusBadgeClass(item)" class="status-pill">
                      {{ statusLabel(item) }}
                    </span>
                  </div>

                  <div class="registration-meta text-muted">
                    <div class="mb-1">
                      Khách hàng:
                      <span class="text-dark font-weight-medium">{{ item.customerName }}</span>
                    </div>
                    <div class="mb-1">
                      Email: {{ item.email }}
                      <span class="mx-2">•</span>
                      SDT: {{ item.phone }}
                    </div>
                    <div class="mb-2">
                      Ngày đăng ký: {{ formatDate(item.registerDate) }}
                      <span class="mx-2">•</span>
                      Hết hạn: {{ formatDate(item.expireDate) }}
                    </div>
                  </div>
                </div>
              </div>

              <div class="text-right">
                <div class="registration-price text-success mb-3">
                  {{ formatPrice(item.price) }} VNĐ
                </div>
                <button class="btn btn-success btn-sm px-5 mr-2" @click="viewDetail(item)">
                  <i class="far fa-eye mr-2"></i>Xem chi tiết
                </button>
                <button
                  v-if="item.status === 'active'"
                  class="btn btn-outline-danger btn-sm px-3"
                  @click="confirmInactivate(item)"
                >
                  <i class="fas fa-ban mr-1"></i>Tắt kích hoạt
                </button>
                <button
                  v-else-if="item.isInactive"
                  class="btn btn-outline-success btn-sm px-3"
                  @click="confirmActivate(item)"
                >
                  <i class="fas fa-check-circle mr-1"></i>Kích hoạt lại
                </button>
              </div>
            </div>
          </div>
        </div>

        <div v-if="registrations.length === 0 && !loading" class="col-12 text-center py-12">
          <i class="fas fa-layer-group fa-3x text-muted mb-4 d-block"></i>
          <p class="text-muted">Chưa có đăng ký nào.</p>
        </div>
      </div>

      <div v-if="paging.total > 0" class="d-flex justify-content-between align-items-center mt-4">
        <div class="d-flex align-items-center">
          <b-form-select
            v-model="paging.pageSize"
            :options="pageSizeOptions"
            size="sm"
            style="width: 80px;"
            class="page-size-select"
          />
        </div>
        <b-pagination
          v-model="paging.page"
          :total-rows="paging.total"
          :per-page="paging.pageSize"
          size="md"
          class="mb-0 pagination-custom"
          first-number
          last-number
        />
      </div>
    </b-overlay>
  </div>
</template>

<script>
import PackageRegistrationBulkImport from './components/PackageRegistrationBulkImport.vue';
import UserBundleOrdersImport from './components/UserBundleOrdersImport.vue';

export default {
  name: 'PackageRegistration',
  components: { PackageRegistrationBulkImport, UserBundleOrdersImport },
  data() {
    return {
      loading: false,
      debounceTimer: null,
      registrations: [],
      filters: {
        phoneNumber: '',
        salePackageId: '',
        status: '',
        dateFrom: '',
        dateTo: '',
      },
      salePackages: [],
      statusOptions: [
        { value: 'active', text: 'Đang hoạt động' },
        { value: 'expired', text: 'Hết hạn' },
      ],
      paging: {
        page: 1,
        pageSize: 12,
        total: 0,
      },
      pageSizeOptions: [
        { value: 6,  text: '6' },
        { value: 12, text: '12' },
        { value: 24, text: '24' },
      ],
      stats: {
        active: 0,
        expired: 0,
        revenue: 0,
      },
    };
  },
  computed: {
    salePackageOptions() {
      return this.salePackages.map((p) => ({ value: p.id, text: p.name }));
    },
    salePackageValue: {
      get() {
        return this.salePackageOptions.find((o) => o.value === this.filters.salePackageId) || null;
      },
      set(obj) {
        this.filters.salePackageId = obj?.value ?? '';
      },
    },
    statusValue: {
      get() {
        return this.statusOptions.find((o) => o.value === this.filters.status) || null;
      },
      set(obj) {
        this.filters.status = obj?.value ?? '';
      },
    },
    searchParams() {
      const params = new URLSearchParams();
      params.append('page', this.paging.page);
      params.append('size', this.paging.pageSize);
      if (this.filters.phoneNumber)   params.append('phoneNumber', this.filters.phoneNumber);
      if (this.filters.salePackageId) params.append('salePackageId', this.filters.salePackageId);
      if (this.filters.status)        params.append('isExpired', this.filters.status === 'expired');
      if (this.filters.dateFrom) {
        const d = this.parsePickerDate(this.filters.dateFrom);
        if (d) params.append('startDate', Math.floor(d.getTime() / 1000));
      }
      if (this.filters.dateTo) {
        const d = this.parsePickerDate(this.filters.dateTo, { endOfDay: true });
        if (d) params.append('endDate', Math.floor(d.getTime() / 1000));
      }
      return params;
    },
    // Filter params dùng cho API count (không có page/size)
    countParams() {
      const params = new URLSearchParams();
      if (this.filters.phoneNumber)   params.append('phoneNumber', this.filters.phoneNumber);
      if (this.filters.salePackageId) params.append('salePackageId', this.filters.salePackageId);
      if (this.filters.status)        params.append('isExpired', this.filters.status === 'expired');
      if (this.filters.dateFrom) {
        const d = this.parsePickerDate(this.filters.dateFrom);
        if (d) params.append('startDate', Math.floor(d.getTime() / 1000));
      }
      if (this.filters.dateTo) {
        const d = this.parsePickerDate(this.filters.dateTo, { endOfDay: true });
        if (d) params.append('endDate', Math.floor(d.getTime() / 1000));
      }
      return params;
    },
  },
  watch: {
    'paging.page'() {
      this.loadRegistrations();
    },
    'paging.pageSize'() {
      this.paging.page = 1;
      this.loadRegistrations();
    },
  },
  mounted() {
    this.loadSalePackages();
    this.loadRegistrations();
    this.loadStats();
  },
  activated() {
    this.loadRegistrations();
    this.loadStats();
  },
  beforeDestroy() {
    if (this.debounceTimer) {
      clearTimeout(this.debounceTimer);
    }
  },
  methods: {
    handleSearch() {
      if (this.debounceTimer) {
        clearTimeout(this.debounceTimer);
      }
      this.debounceTimer = setTimeout(() => {
        this.paging.page = 1;
        this.loadRegistrations();
        this.loadStats();
      }, 2000);
    },

    resetFilters() {
      this.filters = {
        phoneNumber: '',
        salePackageId: '',
        status: '',
        dateFrom: '',
        dateTo: '',
      };
      this.paging.page = 1;
      this.loadRegistrations();
      this.loadStats();
    },

    async loadSalePackages() {
      try {
        const res = await this.$api.get('SalePackage/All');
        const raw = res?.data ?? res;
        const list = Array.isArray(raw) ? raw : (raw?.data ?? raw?.items ?? []);
        this.salePackages = list.map((p) => ({ id: p.Id || p.id, name: p.Name || p.name }));
      } catch (e) {
        console.error('Lỗi tải danh sách gói:', e);
      }
    },

    async loadRegistrations() {
      try {
        this.loading = true;
        const res = await this.$api.get('UserBundleOrders', { params: this.searchParams });
        const raw = res?.data ?? res;

        let items = [];
        let total = 0;

        if (Array.isArray(raw)) {
          items = raw;
          total = raw.length;
        } else if (Array.isArray(raw?.items)) {
          items = raw.items;
          total = raw.total ?? raw.items.length;
        } else if (Array.isArray(raw?.data?.items)) {
          items = raw.data.items;
          total = raw.data.total ?? raw.data.items.length;
        } else if (Array.isArray(raw?.data)) {
          items = raw.data;
          total = raw.total ?? raw.data.length;
        }

        this.registrations = items.map((item) => {
          const acct = item.accountHis || {};
          const tran = item.tranPackage || {};
          const tranItems = tran.items || [];
          const now = Date.now() / 1000;
          const isActive = item.status === 1 && item.endDate > now;

          // itemType: 0 = thuốc, 1 = dịch vụ, 2 = service package
          const remainingMedicine = tranItems.filter((i) => i.itemType === 0).length;
          const remainingService = tranItems.filter((i) => i.itemType === 1 || i.itemType === 2).length;

          // isInactive = manually deactivated (status === 0), not merely expired
          const isInactive = item.status === 0;

          return {
            id: item.id,
            packageName: tran.name || item.salePackage?.name || 'Không rõ gói',
            status: isActive ? 'active' : 'expired',
            isInactive,
            customerName: acct.fullName || acct.firstName || 'Không rõ',
            email: acct.email || '',
            phone: acct.phoneMobile || acct.phoneHome || '',
            registerDate: item.startDate,
            expireDate: item.endDate,
            remainingMedicine,
            remainingService,
            basePrice: item.basePrice || 0,
            price: item.priceBuy || 0,
          };
        });

        this.paging.total = total;
      } catch (error) {
        console.error('Lỗi tải danh sách đăng ký:', error);
        this.$toastr?.e?.({
          title: 'Lỗi',
          msg: 'Không thể tải danh sách đăng ký. Vui lòng thử lại.',
        });
        this.registrations = [];
        this.paging.total = 0;
      } finally {
        this.loading = false;
      }
    },

    async loadStats() {
      try {
        const res = await this.$api.get('UserBundleOrders/bundles-count', {
          params: this.countParams,
        });
        const raw = res?.data ?? res;
        const d = raw?.data ?? raw;
        this.stats = {
          active: d?.item1 ?? 0,
          expired: d?.item2 ?? 0,
          revenue: d?.item3 ?? 0,
        };
      } catch (error) {
        console.error('Lỗi tải thống kê đăng ký:', error);
      }
    },

    statusLabel(item) {
      if (item.status === 'active') return 'Hoạt động';
      return item.isInactive ? 'Đã tắt' : 'Hết hạn';
    },
    statusBadgeClass(item) {
      return item.status === 'active' ? 'pill-active' : 'pill-expired';
    },

    exportReport() {
      this.$toastr?.s?.({ title: 'Thông báo', msg: 'Chức năng xuất báo cáo sẽ được cập nhật.' });
    },
    createRegistration() {
      this.$router.push({ name: 'package_registration_create' });
    },
    openBulkImport() {
      this.$bvModal.show('modal-package-registration-bulk-import');
    },
    openListImport() {
      this.$bvModal.show('modal-user-bundle-orders-import');
    },
    onBulkImportSuccess() {
      this.loadRegistrations();
    },
    viewDetail(item) {
      this.$router.push({
        name: 'package_registration_detail',
        params: { id: item.id },
      });
    },

    async confirmInactivate(item) {
      const ok = await this.$bvModal.msgBoxConfirm(
        `Bạn có chắc muốn tắt kích hoạt gói của khách hàng "${item.customerName}" không?`,
        {
          title: 'Tắt kích hoạt',
          okTitle: 'Tắt kích hoạt',
          cancelTitle: 'Hủy',
          okVariant: 'danger',
          centered: true,
        },
      );
      if (!ok) return;
      try {
        await this.$api.put(`UserBundleOrders/${item.id}/inactivate`, {});
        this.$toastr?.s?.({ title: 'Thành công', msg: 'Đã tắt kích hoạt.' });
        this.loadRegistrations();
      } catch (e) {
        this.$toastr?.e?.({ title: 'Lỗi', msg: e?.message || 'Không thể tắt kích hoạt.' });
      }
    },

    async confirmActivate(item) {
      const ok = await this.$bvModal.msgBoxConfirm(
        `Bạn có chắc muốn kích hoạt lại gói của khách hàng "${item.customerName}" không?`,
        {
          title: 'Kích hoạt lại',
          okTitle: 'Kích hoạt',
          cancelTitle: 'Hủy',
          okVariant: 'success',
          centered: true,
        },
      );
      if (!ok) return;
      try {
        await this.$api.put(`UserBundleOrders/${item.id}/activate`, {});
        this.$toastr?.s?.({ title: 'Thành công', msg: 'Đã kích hoạt lại.' });
        this.loadRegistrations();
      } catch (e) {
        this.$toastr?.e?.({ title: 'Lỗi', msg: e?.message || 'Không thể kích hoạt lại.' });
      }
    },

    formatPrice(val) {
      if (!val && val !== 0) return '0';
      return new Intl.NumberFormat('vi-VN').format(val);
    },
    formatDate(val) {
      if (!val) return '?';
      const d = this.parseAnyDate(val);
      if (!d) return '?';
      return this.$moment(d).format('D/M/YYYY');
    },
    parseAnyDate(val) {
      if (!val) return null;
      if (val instanceof Date) return Number.isNaN(val.getTime()) ? null : val;
      if (typeof val === 'number') {
        const ms = val < 1e10 ? val * 1000 : val;
        const d = new Date(ms);
        return Number.isNaN(d.getTime()) ? null : d;
      }
      if (typeof val === 'string') {
        // Support 'YYYY-MM-DD' and other moment-parseable formats
        const m = this.$moment(val, ['YYYY-MM-DD', 'DD/MM/YYYY', 'D/M/YYYY', 'MM/DD/YYYY'], true);
        if (m.isValid()) return m.toDate();
        const d = new Date(val);
        return Number.isNaN(d.getTime()) ? null : d;
      }
      return null;
    },
    parsePickerDate(val, { endOfDay = false } = {}) {
      if (!val) return null;
      const d = this.parseAnyDate(val);
      if (!d) return null;
      if (endOfDay) {
        const end = new Date(d);
        end.setHours(23, 59, 59, 999);
        return end;
      }
      const start = new Date(d);
      start.setHours(0, 0, 0, 0);
      return start;
    },
  },
};
</script>

<style scoped lang="scss">
.package-registration {
  padding: 0;
}

.filter-bar {
  padding: 16px 20px;
  .row {
    row-gap: 10px;
  }

  ::v-deep .form-group {
    margin-bottom: 0;
    label {
      display: none;
    }
  }

  .filter-col-input {
    display: flex;
    align-items: center;
  }
}

.search-input {
  padding-left: 38px;
  border-radius: 8px;
  border: 1px solid #e1e5e9;
  height: 42px;
}
.search-icon {
  position: absolute;
  left: 12px;
  top: 50%;
  transform: translateY(-50%);
  color: #a1a5b7;
  z-index: 5;
  font-size: 0.85rem;
}
.filter-icon {
  position: absolute;
  left: 12px;
  top: 50%;
  transform: translateY(-50%);
  color: #a1a5b7;
  z-index: 5;
  font-size: 0.82rem;
}
.filter-select {
  height: 42px;
  border-radius: 8px;
  border: 1px solid #e1e5e9;
  font-size: 0.9rem;
}
.pl-icon {
  padding-left: 34px;
}

.summary-card {
  background: #fff;
  border: 1px solid #e4e6ef;
  border-radius: 10px;
  padding: 18px 22px;

  &__label {
    font-size: 0.85rem;
    color: #7e8299;
    margin-bottom: 6px;
  }
  &__value {
    font-size: 2rem;
    font-weight: 700;
    line-height: 1;
  }
}

.registration-card {
  background: #fff;
  border: 1px solid #e4e6ef;
  border-radius: 14px;
  padding: 18px 20px;
  transition: all 0.25s ease;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 30px rgba(76, 87, 125, 0.12);
  }
}

.registration-icon {
  width: 42px;
  height: 42px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #eef6ff;
  color: #3b82f6;
  flex: 0 0 42px;
}

.registration-title {
  font-weight: 700;
  color: #181c32;
  font-size: 1.02rem;
}

.status-pill {
  display: inline-flex;
  align-items: center;
  border-radius: 20px;
  padding: 4px 12px;
  font-size: 0.78rem;
  font-weight: 600;
}
.pill-active {
  background: #e8fff3;
  color: #50cd89;
}
.pill-expired {
  background: #fff5f8;
  color: #f1416c;
}

.registration-meta {
  font-size: 0.88rem;
}

.registration-price {
  font-weight: 700;
  font-size: 1.05rem;
}

.page-size-select {
  border-color: #dee2e6;
  font-size: 0.875rem;
}
::v-deep .pagination-custom {
  .page-item {
    &.active .page-link {
      background-color: #01645A;
      border-color: #01645A;
      color: #fff;
    }
    .page-link {
      color: #21a567;
      &:hover {
        background-color: #e8f8f0;
        border-color: #21a567;
        color: #21a567;
      }
    }
  }
}

</style>